import { motion } from "framer-motion";
import { Baby, School, GraduationCap, Trophy, Medal, Users } from "lucide-react";

const PATHS = [
  { icon: Baby, title: "Youth Athletes", note: "Fundamentals, coordination & confidence" },
  { icon: School, title: "Middle School", note: "Speed, strength & movement foundations" },
  { icon: GraduationCap, title: "High School", note: "Varsity performance & recruiting prep" },
  { icon: Trophy, title: "College", note: "Elite programming for the next level" },
  { icon: Medal, title: "Professional", note: "Peak output, longevity & recovery" },
  { icon: Users, title: "Teams & Organizations", note: "Group training built for your roster" },
];

export default function Pathways() {
  return (
    <section
      id="pathways"
      data-testid="pathways-section"
      className="py-24 md:py-36 bg-[#0a0a0a] border-t border-white/10"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          className="max-w-3xl mb-16"
        >
          <p className="font-mono-accent text-xs tracking-[0.35em] uppercase text-white/40 mb-6">
            Every Level
          </p>
          <h2 className="font-display font-black uppercase tracking-tighter leading-[0.9] text-5xl md:text-7xl">
            Training Pathways
          </h2>
        </motion.div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {PATHS.map((p, i) => {
            const Icon = p.icon;
            return (
              <motion.div
                key={p.title}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.07, duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
                data-testid={`pathway-card-${i}`}
                className="group bg-black border border-white/10 p-8 transition-all duration-500 hover:-translate-y-2 hover:border-white/30 flex items-start gap-5"
              >
                <div className="shrink-0 w-12 h-12 border border-white/15 flex items-center justify-center group-hover:border-white/40 transition-colors duration-300">
                  <Icon size={22} className="text-white/80" strokeWidth={1.5} />
                </div>
                <div>
                  <h3 className="font-display font-bold uppercase tracking-tight text-2xl leading-none mb-2">
                    {p.title}
                  </h3>
                  <p className="text-white/50 text-sm">{p.note}</p>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
